import axios from "../../config/axiosConfig";
import { SUB_JOB_ISSUE_TRANSACTION_REQUEST, SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE, GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO,
  GET_SUB_JOB_ISSUE_TRANSACTIONS } from "../types";

export const getSubJobIssueTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sub-job-issue-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SUB_JOB_ISSUE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSubJobIssueTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/sub-job-issue-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

